/* Giorgio store site: hours status, mobile menu, app links, MenSuits link tagging */
(function () {
  function nowInChattanooga() {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      return { day: days[o.weekday], minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    } catch (e) { return null; }
  }

  function setStatus() {
    var els = document.querySelectorAll('[data-gm-status]');
    if (!els.length) return;
    var t = nowInChattanooga(); if (!t) return;
    var open = 11 * 60, close = 19 * 60, text;
    var isOpenDay = t.day >= 1 && t.day <= 6;
    if (isOpenDay && t.minutes >= open && t.minutes < close) text = 'Open now · until 7pm';
    else if (isOpenDay && t.minutes < open) text = 'Opens today at 11am';
    else if (t.day === 6 || t.day === 0) text = 'Closed now · Opens Monday 11am';
    else text = 'Closed now · Opens tomorrow 11am';
    els.forEach(function (el) { el.textContent = text; });
  }

  function drawer() {
    var d = document.querySelector('[data-gm-drawer]');
    if (!d) return;
    function toggle(open) {
      d.classList.toggle('is-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
      var b = document.querySelector('[data-gm-drawer-open]');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.querySelectorAll('[data-gm-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { toggle(true); }); });
    d.querySelectorAll('[data-gm-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { toggle(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });
  }

  function appLinks() {
    var ua = navigator.userAgent || '';
    var android = /Android/i.test(ua);
    document.querySelectorAll('[data-gm-app]').forEach(function (a) {
      a.href = android ? a.getAttribute('data-android') : a.getAttribute('data-ios');
    });
  }

  function tagMenSuits() {
    var campaign = (document.body.getAttribute('data-gm-campaign') || 'site');
    document.querySelectorAll('a[href*="mensuits.com"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        if (!/(^|\.)mensuits\.com$/.test(u.hostname)) return;
        if (!u.searchParams.has('utm_source')) {
          u.searchParams.set('utm_source', 'giorgiomwh');
          u.searchParams.set('utm_medium', 'referral');
          u.searchParams.set('utm_campaign', a.getAttribute('data-gm-campaign') || campaign);
          a.href = u.toString();
        }
      } catch (e) {}
    });
  }

  function appRedirect() {
    try {
      if (new URLSearchParams(location.search).get('get') !== 'suitmates') return;
      var ua = navigator.userAgent || '';
      if (/Android/i.test(ua)) location.replace('https://play.google.com/store/apps/details?id=com.suitmates.app');
      else if (/iPhone|iPad|iPod/i.test(ua)) location.replace('https://apps.apple.com/us/app/suitmates/id6758317331');
    } catch (e) {}
  }

  function init() { setStatus(); drawer(); appLinks(); tagMenSuits(); }
  appRedirect();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
